export interface VideoCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
  count: number;
}

export const videoCategories: VideoCategory[] = [
  {
    slug: 'dianying',
    name: '电影',
    icon: 'ri-film-line',
    description: '最新院线大片、经典电影、动作片、喜剧片等各类电影资源',
    count: 3280,
  },
  {
    slug: 'dianshiju',
    name: '电视剧',
    icon: 'ri-tv-line',
    description: '热门国产剧、韩剧、美剧、日剧等高清电视剧全集在线观看',
    count: 4521,
  },
  {
    slug: 'zongyi',
    name: '综艺',
    icon: 'ri-emotion-laugh-line',
    description: '热门综艺节目、真人秀、脱口秀、选秀节目等精彩内容',
    count: 1890,
  },
  {
    slug: 'dongman',
    name: '动漫',
    icon: 'ri-rocket-line',
    description: '国产动漫、日本动漫、欧美动画等高清动漫资源',
    count: 2760,
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    icon: 'ri-earth-line',
    description: '自然、历史、科技、人文等各类纪录片，探索未知世界',
    count: 950,
  },
  {
    slug: 'shaoer',
    name: '少儿',
    icon: 'ri-star-smile-line',
    description: '儿童动画、早教资源、亲子节目等适合儿童观看的内容',
    count: 640,
  },
];